/**
 * Internal dependencies
 */
import { CLOSE_MODAL, OPEN_MODAL } from 'state/action-types';

export const createCloseModalAction = (name) => () => ({
    type: CLOSE_MODAL,
    meta: {
        modal: {
            name,
        },
    },
});

export const createOpenModalAction = (name) => (data = {}) => ({
    type: OPEN_MODAL,
    payload: { data },
    meta: {
        modal: {
            name,
        },
    },
});

export const closeModal = (name) => (dispatch) => dispatch(createCloseModalAction(name)());

export const openModal = (name) => (dispatch) => dispatch(createOpenModalAction(name)());
